/**
 * Arcℏimedian DSaaS — Loading Screen
 */

import React from 'react';
import { theme } from '../theme';

export function LoadingScreen() {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: theme.bg,
      flexDirection: 'column',
      gap: 16,
    }}>
      <div style={{
        width: 44,
        height: 44,
        border: `3px solid ${theme.surface}`,
        borderTopColor: theme.accent,
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
      }} />
      <span style={{
        color: theme.textDim,
        fontSize: 14,
        fontFamily: theme.fontSans,
        letterSpacing: '0.05em',
      }}>
        Loading…
      </span>
    </div>
  );
}
